import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Card, Btn, Badge } from "@/components/UI";
import { ArrowLeft, Pencil, Wallet } from "lucide-react";
import { CustomerFormModal } from "@/components/customers/CustomerFormModal";
import { CustomerTypeBadge } from "@/components/customers/CustomerTypeBadge";
import { typeOf } from "@/lib/customers";

function Field({ label, value, testid }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-0.5">{label}</div>
      <div className="text-sm text-slate-800 whitespace-pre-line break-words" data-testid={testid}>{value || "—"}</div>
    </div>
  );
}

export default function CustomerDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [c, setC] = useState(null);
  const [error, setError] = useState("");
  const [edit, setEdit] = useState(false);
  useEffect(() => { api.get(`/customers/${id}`).then(setC).catch(() => setError("Müşteri bulunamadı")); }, [id]);

  if (error) return <div className="p-6 text-rose-600" data-testid="cust-detail-error">{error}</div>;
  if (!c) return <div className="p-6 text-slate-500">Yükleniyor…</div>;
  return (
    <div data-testid="customer-detail-page">
      <PageHeader title={c.legal_name}
        description={<span className="font-mono text-xs" data-testid="cust-detail-code">{c.code}</span>}
        actions={<div className="flex gap-2">
          <Btn variant="secondary" onClick={() => nav("/customers")} data-testid="cust-detail-back"><ArrowLeft size={14} /> Listeye Dön</Btn>
          <Btn onClick={() => setEdit(true)} data-testid="cust-detail-edit"><Pencil size={14} /> Düzenle</Btn>
        </div>} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <Card className="p-5 lg:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <CustomerTypeBadge type={c.customer_type} testid="cust-detail-type" />
            <Badge level={c.active ? "ok" : "inactive"}>{c.active ? "Aktif" : "Pasif"}</Badge>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <Field label="Yetkili Kişi" value={c.contact_name} testid="cust-detail-contact" />
            <Field label="Telefon" value={c.phone} testid="cust-detail-phone" />
            <Field label="E-posta" value={c.email} testid="cust-detail-email" />
            <Field label="Telegram" value={c.telegram_username ? `@${c.telegram_username}` : ""} testid="cust-detail-telegram" />
            <div className="sm:col-span-2"><Field label="Adres" value={c.billing_address} testid="cust-detail-address" /></div>
            <div className="sm:col-span-2"><Field label="Notlar" value={c.notes} testid="cust-detail-notes" /></div>
          </div>
        </Card>
        <div className="space-y-4">
          <Card className="p-5">
            <Field label="Varsayılan Vade" value={`${c.default_payment_days || 0} gün`} testid="cust-detail-days" />
            <div className="mt-4"><Field label="Fiyat Grubu" value={typeOf(c.price_group)?.label || "—"} testid="cust-detail-price-group" /></div>
            <div className="text-[11px] text-slate-500 mt-1">Müşteri tipine göre otomatik belirlenir.</div>
          </Card>
          <Card className="p-5 border-dashed" data-testid="cust-detail-ledger-placeholder">
            <div className="flex items-center gap-2 text-sm font-semibold text-slate-700"><Wallet size={16} /> Cari Hesap</div>
            <div className="text-xs text-slate-500 mt-1">Bakiye, tahsilat ve cari hareketler Muhasebe aşamasında bu karta bağlanacak.</div>
          </Card>
        </div>
      </div>
      <CustomerFormModal open={edit} customer={c} onClose={() => setEdit(false)}
        onSaved={(saved) => { setC(saved); setEdit(false); }} />
    </div>
  );
}
